export default __webpack_public_path__ + "static/MobilityasaServiceMaaS-d72a034d87a8bcc6ed3f41b0d46c3171.jpg";